import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is my real phone number ever shared?",
    a: "Never. The SECQRE relay creates a one-time bridge for each call. The caller sees a temporary number; you receive the call on your real one. The two are never linked publicly.",
  },
  {
    q: "Do I need to keep paying every month?",
    a: "No. SECQRE is a one-time purchase. The relay, app, scan analytics and lifetime masked calls are included — no recurring subscription.",
  },
  {
    q: "What if I switch cars?",
    a: "Transfer your SECQRE tag to a new vehicle from the app in 10 seconds, or order a replacement sticker for $5 with free shipping on orders over $25.",
  },
  {
    q: "Will it work without internet on the scanner's phone?",
    a: "The QR code points to a short-link URL, so the scanner does need an internet connection. The NFC variant works offline — and we include free QR-only replacements with every order.",
  },
  {
    q: "How do you stop spam calls?",
    a: "We cap each call at 90 seconds, rate-limit per device and per IP, and let you block a number from your app in one tap. Spammers don't get a foothold.",
  },
  {
    q: "Is SECQRE available outside the US?",
    a: "We're launching in the United States in 2026 as our flagship market. Our sister brand Sampark serves over 950,000 drivers across South Asia today.",
  },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="section-pad bg-white">
      <div className="container-secqre grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <span className="overline">— FAQ</span>
          <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl tracking-tight" data-testid="faq-heading">
            Quick answers to slow your skepticism.
          </h2>
          <p className="mt-5 text-[#475569]">Still have questions? <a href="/contact" className="underline decoration-[#FFD600] decoration-4 underline-offset-4 hover:text-[#0A0A0A]">Ask us anything →</a></p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E2E8F0]">
                <AccordionTrigger className="text-left font-heading text-lg md:text-xl font-semibold py-6 hover:no-underline hover:text-[#0F172A]" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#475569] leading-relaxed text-base pb-6" data-testid={`faq-content-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
